import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { getAuth, PhoneAuthProvider, RecaptchaVerifier, updatePassword, updatePhoneNumber } from "firebase/auth";
import { BehaviorSubject, catchError, firstValueFrom, map, Observable, of, ReplaySubject } from "rxjs";
import { CommonVariable } from "../app.constants";
import { ComponentModule } from "../components/component.module";
import { UserManagementService } from "../services/user-management.service";
import { UtilityService } from "./utility.service";
@Injectable({
  providedIn: ComponentModule,
})
export class CaptchaService {
  private windowRef: any;
  user$ = new ReplaySubject(1);
  captchaSolved$ = new BehaviorSubject(false);
  otpSent$ = new BehaviorSubject(false);
  verificationCode: any;
  verificationId: any;
  selectedLanguage: string = "en";
  private readonly ipifyUrl = 'https://api.ipify.org?format=json';

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private functions: AngularFireFunctions,
    private usermanagementService: UserManagementService
  ) {
    //  this.captchaSolved$.next(false);
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        // translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }

  resetRecaptcha() {
    this.otpSent$.next(false);
    // this.windowRef.recaptchaVerifier.reset();
    //this.windowRef.recaptchaVerifier.clear();
  }
  renderCaptcha() {
    // this.windowRef.recaptchaVerifier.reset();
    try {
      let captchaElement = document.getElementById("captcha-container");
      if (captchaElement) {
        const auth = getAuth();
        auth.languageCode = this.authService?.selectedlanguage$?.value
          ? this.authService?.selectedlanguage$?.value
          : this.selectedLanguage;
        //firebase.auth().useDeviceLanguage();
        this.user$.next(false);
        //this.captchaSolved$.next(false);
        this.windowRef = window;

        if (!this.windowRef.recaptchaVerifier) {
          this.windowRef.recaptchaVerifier = new RecaptchaVerifier(
            auth,
            "captcha-container",
            {
              callback: () => {
                this.captchaSolved$.next(true);
              },
              "expired-callback": () => {
                this.captchaSolved$.next(false);
              },
              "error-callback": (error) => {
                this.captchaSolved$.next(false);
              },
            },);

          this.windowRef.recaptchaVerifier.render();
        }
      }
    } catch (e) {
      return e;
      // this.windowRef.recaptchaVerifier.reset();
      // this.windowRef.recaptchaVerifier.clear();
      // this.renderCaptcha()
    }
  }
  getPublicIp$(): Observable<string | null> {
    return this.http.get<any>(this.ipifyUrl).pipe(
      map(res => res.ip ?? null),
      catchError(err => {
        return of(null);
      })
    );
  }
  async sendLoginCode(phoneNumber: string): Promise<any> {
    try {
      const ip = await firstValueFrom(this.getPublicIp$());
      if (ip) {
        CommonVariable.userIP = ip;
        localStorage.setItem("ip", ip);
      }

      // ✅ Prepare rest of the payload
      const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(phoneNumber);
      const msn = phoneNumber.slice(1);
      const type = 'PwaSendOTP';
      const env = 'livelottobytext';
      const sms_function = 'Pwa_Send_OTP';
      const hash = UtilityService.createHash(msn, type, env);
      const userIP = ip ?? CommonVariable.userIP ?? localStorage.getItem("ip");
      const preferredLanguage =
        localStorage.getItem('language_code') ||
        this.authService?.selectedlanguage$?.value ||
        'en';

      const reqParams = isEmail
        ? { email: phoneNumber, otp_for: "email", userIP, language_code: preferredLanguage }
        : { msn, env, hash, sms_function, type, userIP, language_code: preferredLanguage };

      // ✅ Call backend with updated payload
      return await firstValueFrom(
        this.authService.getV2CloudFunction("sendloginotpv2", reqParams)
      );
    } catch (err) {
      console.error("Failed to send login code", err);
      throw err;
    }
  }


  verifyPhoneNumber(phoneNumber) {
    if (!phoneNumber) return;
    this.otpSent$.next(false);
    if (phoneNumber != undefined) {
      this.sendLoginCode(phoneNumber)
        .then((res: Data) => {
          if (res.status == "success") {
            this.otpSent$.next(true);
            this.authService?.otpFail$?.next(false);
          } else {
            this.authService?.otpFail$?.next(true);
          }
        })
        .catch((err) => {
          return err;
        });
    }
    // const auth = getAuth();
    // var provider = new PhoneAuthProvider(auth);
    // const appVerifier = this.windowRef.recaptchaVerifier;
    // provider.verifyPhoneNumber(phoneNumber, appVerifier).then((data) => {
    //   this.verificationId = data;
    //   this.otpSent$.next(true);
    // });
  }

  verifyCode(verificationCode, msn) {
    const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(msn);
    const msnWithCountryCode = msn.slice(1);
    const env = 'livelottobytext';
    const type = 'PwaCheckOTP';
    const sms_function = 'Pwa_Check_OTP';
    const hash = UtilityService.createHashForVerifyOtp(msnWithCountryCode, verificationCode, type, env);
    const userIP = CommonVariable.userIP ?? localStorage.getItem("ip");
    const params = {
      env,
      hash,
      ipaddress: CommonVariable.userIP,
      msn: msnWithCountryCode,
      code: verificationCode,
      sms_function,
      type
    };
    const emailParams = {
      email: msn,
      otp_for: "email",
      ipaddress: userIP,
      code: verificationCode
    }
    const reqParams = isEmail ? emailParams : params;
    return this.authService.getV2CloudFunction('verifyloginotpv2', reqParams);
  }

  updatePhoneNumber(verificationCode) {
    var credential = PhoneAuthProvider.credential(this.verificationId, verificationCode);
    const auth = getAuth();
    return updatePhoneNumber(auth.currentUser, credential);
  }

  setNewPassword(password: string) {
    const auth = getAuth();
    var user = auth.currentUser;
    return updatePassword(user, password);
  }
}
